import { useQuery } from "@tanstack/react-query";
import { getApiCodelistManagementImportEnvironments } from "Infrastructure/Api/Api";

export const IMPORT_ENVIRONMENTS_QUERY_KEY = "IMPORT_ENVIRONMENTS_QUERY";

export function useImportEnvironmentsQuery() {
	return useQuery({
		queryKey: [IMPORT_ENVIRONMENTS_QUERY_KEY],
		queryFn: () => getApiCodelistManagementImportEnvironments(),
	});
}
